<template>
    <div class="sales-report__vendors">
        <Vendor v-for="vendor in vendors" :key="vendor.id" :vendor="vendor"></Vendor>
    </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import Vendor from './ReportVendor.vue';

  export default {
    name: 'ReportVendors',
    components: {
      Vendor,
    },
    computed: {
      ...mapGetters('purchaseActivityFlash', ['contents']),
      vendors() {
        return this.contents.totalsByVendor;
      },
    },
  };
</script>
